import { useTranslate } from '@tolgee/react';
import { GetStaticProps } from 'next';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { getNavigation, getPartners, NavigationProps } from '@amf/shared/utils/navigation';
import { getLanguageLocale } from '@amf/shared/utils/languages';
import Container from '@amf/shared/components/layout/Container';
import ContactSend from '@amf/shared/components/contact/ContactSend';

import Layout from 'components/layout/Layout';
import Meta from 'components/Meta';

interface ContactPageProps extends NavigationProps {}

export default function ContactPage({ navigation, partners }: ContactPageProps) {
  const { t } = useTranslate();
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY}
      scriptProps={{
        async: true,
        defer: true,
        appendTo: 'head',
      }}
    >
      <div className='ContactPage'>
        <Layout navigation={navigation} partners={partners}>
          <Meta title={t('contact.title')} />
          <Container>
            <h1>{t('contact.title')}</h1>
            <div className='ContactPage__content'>
              <ContactSend buttonProps={{ variant: 'dark' }} />
              <div className='ContactPage__info'>
                <div className='ContactPage__infoPanel'>
                  <h2>{t('contact.info.title')}</h2>
                  <p>
                    <a href='mailto:borkyliga@seznam.cz'>borkyliga@seznam.cz</a>
                    <br />
                    <a href='tel:+420720184504'>+420 720 184 504</a>
                  </p>
                </div>
                <div className='ContactPage__infoPanel'>
                  <h2>{t('contact.billing.title')}</h2>
                  <address>
                    <strong>MF Kolín, z.s.</strong>
                    <br />
                    Kutnohorská 40
                    <br />
                    280 02 Kolín IV
                  </address>
                  <p>IČ: 21432767</p>
                  <p>{t('contact.billing.account')}: 6615310379/0800</p>
                </div>
                <div className='ContactPage__infoPanel'>
                  <h2>{t('contact.social.title')}</h2>
                  <p>
                    <a
                      href='https://www.facebook.com/www.borkyliga.cz/'
                      target='_blank'
                      rel='noreferrer'
                    >
                      Facebook
                    </a>
                  </p>
                  <p>
                    <a href='https://www.instagram.com/mf_kolin/' target='_blank' rel='noreferrer'>
                      Instagram
                    </a>
                  </p>
                </div>
              </div>
            </div>
            <h2 className='h1'>{t('contact.persons.title')}</h2>
            <div className='ContactPage__personList'>
              <div className='ContactPage__person'>
                <div className='ContactPage__personPhoto' />
                <div className='ContactPage__personInfo'>
                  <h3>Jiří Gač</h3>
                  <p>Vedení soutěže</p>
                </div>
              </div>
              <div className='ContactPage__person'>
                <div className='ContactPage__personPhoto' />
                <div className='ContactPage__personInfo'>
                  <h3>Tomáš Šulc</h3>
                  <p>Vedení soutěže</p>
                </div>
              </div>
              <div className='ContactPage__person'>
                <div className='ContactPage__personPhoto' />
                <div className='ContactPage__personInfo'>
                  <h3>Petr Procházka</h3>
                  <p>Vedení soutěže</p>
                </div>
              </div>
            </div>
          </Container>
        </Layout>
      </div>
    </GoogleReCaptchaProvider>
  );
}

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      navigation: await getNavigation(getLanguageLocale(locale!)),
      partners: await getPartners(),
    },
    revalidate: 10,
  };
};
